import { render } from "./PagesHeader.vue?vue&type=template&id=0b8b53c6&scoped=true"
const script = {}

import "./PagesHeader.vue?vue&type=style&index=0&id=0b8b53c6&lang=scss&scoped=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8b53c6"],['__file',"resources/ts/frontend/components/PagesHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b8b53c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b8b53c6', __exports__)) {
    console.log('reload')
    api.reload('0b8b53c6', __exports__)
  }
  
  module.hot.accept("./PagesHeader.vue?vue&type=template&id=0b8b53c6&scoped=true", () => {
    console.log('re-render')
    api.rerender('0b8b53c6', render)
  })

}


export default __exports__